import { resolveBackendUrl } from '@/context/AuthContext';

/**
 * Log out of the AOC and of Keycloak.
 *
 * Clearing local storage is not logging out: the Keycloak session lives in a
 * cookie on the Keycloak host, so the next visit to /login is signed straight
 * back in through SSO and the person who clicked "Log out" is still logged in.
 * The backend ends that session for us over the admin API, which is why this
 * call is the part that matters and the local clean-up is the part that is
 * merely tidy.
 */
export const handleLogout = async () => {
  const accessToken = localStorage.getItem('access_token');
  try {
    const response = await fetch(`${resolveBackendUrl(window.location.hostname)}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    });
    if (!response.ok) {
      console.error('Keycloak session was not ended, so this is a half logout:', response.status);
    }
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('id_token');
    window.location.href = '/login';
  }
};
